<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <GeneralDialogTemplate @close="closeDialog">
        <v-row
            v-if="is_loading === true"
            align="center"
            justify="center"
        >
            <LoaderDefault/>
        </v-row>
        <template slot="header">
            <span class="font-weight-medium title">{{ $t("Edit members") }}</span>
        </template>
        <form v-if="is_loading === false">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-radio-group
                        v-model="assign_user_form.action"
                        :error-messages="assign_user_form.action_error"
                        class="mt-2"
                        row
                    >
                        <v-radio
                            v-for="(action, index) in actions"
                            :key="index"
                            :disabled="is_loading"
                            :label="action.text"
                            :value="action.value"
                            color="primary"
                            class="pr-5"
                        />
                    </v-radio-group>
                </v-col>
                <v-col :cols="assign_user_form.action === 'assign' ? 8 : 12">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <ComboboxDropdown
                                :items="users"
                                :selected="users.filter(x => x.id === assign_user_form.person_id)"
                                name-key="name"
                                value-key="id"
                                show-selected-first
                                :label="$t('Select user')"
                                :searchable="true"
                                :disabled="is_loading"
                                :error-messages="assign_user_form.person_id_error"
                                v-on="on"
                                @input="assign_user_form.person_id = $event.id"
                            />
                        </template>
                        <span v-if="assign_user_form.action === 'assign'">
                            {{ $t("Member will be assigned to every selected client") }}
                        </span>
                        <span v-if="assign_user_form.action === 'unassign'">
                            {{ $t("Member will be removed from all selected clients") }}
                        </span>
                        <span v-if="assign_user_form.action === 'reassign'">
                            {{ $t("Member will be removed from all selected clients") }}
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col
                    v-if="assign_user_form.action === 'assign'"
                    cols="4"
                    class="pl-4"
                >
                    <ComboboxDropdown
                        :items="roles"
                        :selected="roles.filter(x => x.name === assign_user_form.role)"
                        name-key="title"
                        value-key="name"
                        show-selected-first
                        :label="$t('Role')"
                        :error-messages="assign_user_form.role_error"
                        @input="assign_user_form.role = $event.name"
                    />
                </v-col>
                <v-col
                    v-if="assign_user_form.action === 'reassign'"
                    cols="8"
                >
                    <ComboboxDropdown
                        :items="users"
                        :selected="users.filter(x => x.id === assign_user_form.new_person_id)"
                        name-key="name"
                        value-key="id"
                        show-selected-first
                        :label="$t('Assign user')"
                        :searchable="true"
                        :disabled="is_loading"
                        :error-messages="assign_user_form.new_person_id_error"
                        @input="assign_user_form.new_person_id = $event.id"
                    />
                </v-col>
                <v-col
                    v-if="assign_user_form.action === 'reassign'"
                    cols="4"
                    class="pl-4"
                >
                    <ComboboxDropdown
                        :items="roles"
                        :selected="roles.filter(x => x.name === assign_user_form.role)"
                        name-key="title"
                        value-key="name"
                        show-selected-first
                        :label="$t('Role')"
                        :error-messages="assign_user_form.role_error"
                        @input="assign_user_form.role = $event.name"
                    />
                </v-col>
                <v-col
                    v-if="assign_user_form.action === 'reassign' || assign_user_form.action === 'assign'"
                    cols="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-checkbox
                                slot="activator"
                                v-model="assign_user_form.set_default_person"
                                :disabled="is_loading"
                                :error-messages="assign_user_form.set_default_person_error"
                                :label="$t('Set as primary user')"
                                class="mt-3"
                                color="primary"
                                hide-details
                                v-on="on"
                            />
                        </template>
                        {{ $t("Added as a default user when adding a task plan") }}
                    </v-tooltip>
                </v-col>
                <v-col
                    v-if="assign_user_form.action !== 'unassign'"
                    cols="12"
                    md="12"
                    sm="12"
                >
                    <v-checkbox
                        v-model="assign_user_form.assign_incomplete_tasks"
                        :disabled="is_loading"
                        :error-messages="assign_user_form.assign_incomplete_tasks_error"
                        :label="assign_tasks_label"
                        class="mt-3"
                        color="primary"
                        hide-details
                    />
                    <v-checkbox
                        v-model="assign_user_form.assign_template_tasks"
                        :disabled="is_loading"
                        :error-messages="assign_user_form.assign_template_tasks_error"
                        :label="assign_plan_tasks_label"
                        class="mt-3"
                        color="primary"
                        hide-details
                    />
                </v-col>
                <v-col
                    v-if="assign_user_form.action === 'unassign'"
                    cols="12"
                    md="12"
                    sm="12"
                >
                    <v-checkbox
                        v-model="assign_user_form.unassign_incomplete_tasks"
                        :disabled="is_loading"
                        :error-messages="assign_user_form.unassign_incomplete_tasks_error"
                        :label="$t('Remove from new tasks')"
                        class="mt-3"
                        color="primary"
                        hide-details
                    />
                    <v-checkbox
                        v-model="assign_user_form.unassign_template_tasks"
                        :disabled="is_loading"
                        :error-messages="assign_user_form.unassign_template_tasks_error"
                        :label="$t('Remove from plan tasks')"
                        class="mt-3"
                        color="primary"
                        hide-details
                    />
                </v-col>
            </v-row>
        </form>
        <template
            v-if="is_loading === false"
            slot="footer"
        >
            <v-spacer />
            <v-btn
                color="primary"
                text
                @click="closeDialog()"
            >
                {{ $t("Cancel") }}
            </v-btn>
            <v-btn
                class="px-5"
                color="primary inverted--text"
                @click="onSaveClick()"
            >
                {{ $t("Save") }}
            </v-btn>
        </template>
    </GeneralDialogTemplate>
</template>

<script>
import Vue from "vue";
import {computed, ref, watch} from "@vue/composition-api";
import GeneralDialogTemplate from "../Dialog/GeneralDialogTemplate";
import DialogModule from "../../store/modules/dialog";
import ClientModule from "../../store/modules/client";
import AppModule from "../../store/modules/app";
import LoaderDefault from '@/components/LoaderDefault.vue'
import {$t} from "../../i18n";
import ComboboxDropdown from "../../components/ComboboxDropdown";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {useMemberStore} from "../../store/modules/member";

export default {
    name: "EditClientUsersForm",
    components: {
        GeneralDialogTemplate,
        LoaderDefault,
        ComboboxDropdown
    },
    props: {
        dialogIndex: {
            type: Number,
            default: null
        }
    },
    setup(props) {
        const is_loading = ref(false);

        const actions = [
            {text: $t("Add"), value: "assign", tooltip: $t("Member will be assigned to every selected client")},
            {text: $t("Replace"), value: "reassign", tooltip: $t("Member will be removed from all selected clients")},
            {text: $t("Remove"), value: "unassign", tooltip: $t("Member will be removed from all selected clients")}
        ];
        const {dialogs, closeDialog, setConfirmOptions, openConfirmDialog} = DialogModule();
        const {
            handleErrorResponse,
            clearValidationErrors
        } = AppModule();
        const {executeClientsAction} = ClientModule();
        const memberStore = useMemberStore()

        const dialogPayload = dialogs.value[props.dialogIndex].payload
        const account_id = computed(() => dialogPayload.account_id);
        const client_id_list = computed(() => dialogPayload.client_id_list);
        const assign_user_form = ref(null);

        const users = computed(function () {
            let tmp_users = memberStore.getMembersByCompany(account_id.value);

            return tmp_users.sort(function (a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        });
        const roles = [
            {name: "admin", title: $t("Admin")},
            {name: "user", title: $t("Member")}
        ];

        const select_rem_user = computed(function () {
            return assign_user_form.value.action === "assign" ? $t("Select user") : $t("Remove user");
        });
        const assign_tasks_label = computed(() =>
            assign_user_form.value.action === "assign" ? $t("Assign to incomplete tasks") : $t("Reassign incomplete tasks")
        );
        const assign_plan_tasks_label = computed(() =>
            assign_user_form.value.action === "assign" ? $t("Assign to plan tasks") : $t("Reassign plan tasks")
        );

        const load_data = async function () {
            let data = {
                client_id_list: [],
                action: "assign",
                company_id: account_id.value,
                person_id: null,
                new_person_id: null,
                role: "admin",
                set_default_person: false,
                assign_incomplete_tasks: false,
                assign_template_tasks: false,
                unassign_incomplete_tasks: false,
                unassign_template_tasks: false
            };

            assign_user_form.value = Vue.prepare_form_data(data, {
                action: "choice_single",
                person_id: "integer",
                new_person_id: "integer",
                role: "choice_single"
            });
        };

        const onConfirmClick = function () {
            let data = {
                account_id: account_id.value,
                client_id_list: assign_user_form.value.client_id_list,
                action: assign_user_form.value.action,
                company_id: assign_user_form.value.company_id,
                person_id: assign_user_form.value.person_id
            };

            if (assign_user_form.value.action === "unassign") {
                data.unassign_incomplete_tasks = assign_user_form.value.unassign_incomplete_tasks ? 1 : 0;
                data.unassign_template_tasks = assign_user_form.value.unassign_template_tasks ? 1 : 0;
            } else {
                if (assign_user_form.value.action === "reassign") {
                    data.new_person_id = assign_user_form.value.new_person_id;
                }
                data.assign_incomplete_tasks = assign_user_form.value.assign_incomplete_tasks ? 1 : 0;
                data.assign_template_tasks = assign_user_form.value.assign_template_tasks ? 1 : 0;
                data.set_default_person = assign_user_form.value.set_default_person ? 1 : 0;
                data.role = assign_user_form.value.role;
            }

            executeClientsAction(data)
                .then(function () {
                    closeDialog();
                })
                .catch(function (ex) {
                    handleErrorResponse(assign_user_form.value, ex);
                });
        };

        const onSaveClick = function () {
            clearValidationErrors(assign_user_form);

            assign_user_form.value.company_id = account_id.value;
            assign_user_form.value.client_id_list = client_id_list.value;

            if (assign_user_form.value.action === "unassign") {
                setConfirmOptions({
                    title: $t("Warning!"),
                    text: $t("Owner will be assigned to tasks if the removed user was the last assigned user."),
                    confirm_text: $t("Continue"),
                    cancel_text: $t("Cancel"),
                    action: onConfirmClick
                });
                openConfirmDialog();
                is_loading.value = true
            } else {
                is_loading.value = true
                onConfirmClick();
            }
        };

        watch (() => dialogPayload, val => {
            if (val) load_data();
        }, { immediate: true });

        return {
            is_loading,
            closeDialog,
            assign_user_form,
            users,
            roles,
            assign_plan_tasks_label,
            assign_tasks_label,
            select_rem_user,
            onSaveClick,
            actions,
        };
    }
};
</script>
